<template>
  <div id="footer">
    <div class="container">
      <div class="row">
        <div class="col-6 align-self-center">
          <div class="row">
            <img src="../assets/logo_white.png"  style="height:50px" alt="">
          </div>
        </div>
        <div class="col-6">
          <ul>
            <li>
              POWERED BY: <a href="" style="color:rgb(170,3,31)">credmap.org</a>
            </li>
            <li>
              <a href="#">TERMS AND CONDITIONS</a>
            </li>
            <li>
              <a href="#">
                PRIVACY POLICY
              </a>
            </li>
          </ul>
        </div>
      </div>
      
      <!-- <div class="row">
        <div class="col pb-4">
          <p class="text-center" style="color:#fff; opacity:.5">Copyright &copy; 2020 AVRIVA.org | All Right Reserved</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
/*--------------------- FOOTER ------------------*/
#footer{
  padding-top:50px;
  background:#000;
}
#footer ul {
  float:right;
}
#footer ul li{
  list-style: none;
  color:#fff;
  padding:5px 0;
  font-size: .8em !important;
}
#footer ul li a{
  text-decoration: none;
  color:#fff;
}
</style>